export const CONFIG_PLANTILLA_ID = "factura_default";

// PAGO UNICO EXHIBICION o PPD PARCIALES POR DEFINIR
export const METODO_PAGO = "PUE"; // PUE || PPD

export const MONEDA = "MXN";

export const TIPO_CAMBIO = 1;

// INGRESO, EGRESO, TRASLADO, NOMINA, PAGO
export const TIPO_COMPROBANTE = "I";

export const LEYENDA_FOLIO = "FACTURA_";

export const METODO_PAGO_EFECTIVO = "01";
export const METODO_PAGO_CHEQUE = "02";
export const METODO_PAGO_TRANSF = "03";
export const METODO_PAGO_TCREDITO = "04";
export const METODO_PAGO_TDEBITO = "28";
export const METODO_PAGO_POR_DEFINIR = "99";

export const REGIMEN_FISCAL = "612";

export const RFC_GENERICO = "XAXX010101000";

export const NOBRE_GENERICO = "Publico en general";

export const USO_CFDI_GENERICO = "G03";

export const CBB_SEND_EMAIL = "telcelsierramovil@outlook.com";
